import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import CardLink, { cardLinkImageStyles } from '~components/Card/CardLink';
import Heading from '~components/Heading';

const Stories: React.FC = () => (
  <div tw="py-24 bg-blue text-gray-50">
    <div tw="container">
      <Heading level="h2" tw="mt-0">
      Histoires
      </Heading>
      <div tw="grid gap-12 lg:(grid-cols-3 grid-rows-1)">
        <div tw="lg:(col-span-2 row-span-1)">
          <CardLink
            to="/accelerating-research/new-therapies"
            variant="light"
            title="Partenariat pour vaincre le diabète IRSC-FRDJ à l’aide de nouvelles thérapies et de technologies interactives afin de réduire le risque d’hypoglycémie"
          >
            <StaticImage
              src="../../images/researcher-looking-forward-at-the-camera.jpg"
              alt=""
              style={cardLinkImageStyles}
            />
          </CardLink>
        </div>
        <div tw="lg:(col-span-1 row-span-1)">
          <CardLink
            to="/accelerating-research/cell-replacement"
            variant="light"
            title="Les progrès canadiens en matière de recherche de remplacement cellulaire"
          >
            <StaticImage src="../../images/dna.jpg" alt="" style={cardLinkImageStyles} />
          </CardLink>
        </div>
        <div tw="lg:(col-span-1 row-span-1)">
          <CardLink
            to="/accelerating-research/disease-modifying-therapy"
            variant="light"
            title="Le projet de financement du DT1 donne des résultats positifs en matière de thérapie modificatrice"
          >
            <StaticImage
              src="../../images/research-looking-through-microscope.jpg"
              alt=""
              style={cardLinkImageStyles}
            />
          </CardLink>
        </div>
        <div tw="lg:(col-span-2 row-span-1)">
          <CardLink
            to="/accelerating-research/stem-cell-therapies"
            variant="light"
            title="FRDJ et l’IRSC annoncent des nouvelles subventions pour accélérer les thérapies à base de cellules souches pour le diabète de type 1"
          >
            <StaticImage
              src="../../images/two-researchers.jpg"
              alt=""
              style={cardLinkImageStyles}
            />
          </CardLink>
        </div>
      </div>
    </div>
  </div>
);

export default Stories;
